import {Injectable} from '@angular/core';
import {RegistrationUser} from './registration-user';

@Injectable()
export class RegistrationUserCustomer extends RegistrationUser {
  fotoPerfil: string;
  fotoIndentificacionDelante: string;
  fotoIndentificacionReverso: string;
}
